import * as Icons from "lucide-react";

// Renders a lucide icon by name string, with a safe fallback.
export const AppIcon = ({ name, className }) => {
  const Cmp = (name && Icons[name]) || Icons.AppWindow;
  return <Cmp className={className} />;
};

// Curated list of icon names admins can pick from.
export const ICON_OPTIONS = [
  "AppWindow", "Building2", "Calculator", "ShieldCheck", "FileText", "Users",
  "BarChart3", "Briefcase", "Car", "HeartPulse", "Home", "Landmark",
  "PiggyBank", "Wallet", "Receipt", "ClipboardList", "Globe", "Mail",
  "Phone", "Settings", "Database", "Cloud", "LineChart", "Coins",
];
